<template>
    <div
            v-if="order.clientPhone === '**********'"
            v-b-tooltip.hover
            title="Номер телефона клиента доступен только для заказов в статусе 'В работе'. Если вам необходимо связаться с клиентом, то свяжитесь с ответственным мереджером в отделе продаж"
    >
        <span v-if="order.clientPhone">+7</span>{{order.clientPhone}} {{order.clientName}}
        <div class="small">Ответственный {{order.user.firstname}} {{order.user.lastname}}</div>
    </div>
    <div v-else="">
        <span v-if="order.clientPhone">+7</span>{{order.clientPhone}} {{order.clientName}}
        <div class="small">Ответственный {{order.user.firstname}} {{order.user.lastname}}</div>
    </div>
</template>
<script>
  export default{
    props: ['order'],
    computed: {
        //
    },
    data () {
      return {
        loading: false,
        progressBarWidth: 0
      }
    },
    methods: {
      //
    },
    created () {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// OrderClientInfo.vue?13add9f2